import React from "react";
// react plugin for creating charts
import ChartistGraph from "react-chartist";
// @material-ui/core
import { makeStyles } from "@material-ui/core/styles";
import Icon from "@material-ui/core/Icon";
// @material-ui/icons
import Dashboard1 from "@material-ui/icons/Dashboard";
import Store from "@material-ui/icons/Store";
import Warning from "@material-ui/icons/Warning";
import DateRange from "@material-ui/icons/DateRange";
import LocalOffer from "@material-ui/icons/LocalOffer";
import Update from "@material-ui/icons/Update";
import ArrowUpward from "@material-ui/icons/ArrowUpward";
import AccessTime from "@material-ui/icons/AccessTime";
import Accessibility from "@material-ui/icons/Accessibility";
import BugReport from "@material-ui/icons/BugReport";
import Code from "@material-ui/icons/Code";
import Cloud from "@material-ui/icons/Cloud";
import LockIcon from "@material-ui/icons/Lock";
import LibraryBooksIcon from '@material-ui/icons/LibraryBooks';
import AddIcon from '@material-ui/icons/Add';
import PhotoSizeSelectSmallIcon from '@material-ui/icons/PhotoSizeSelectSmall';
import Typography from "views/Typography/Typography.js";


// core components
import GridItem from "components/Grid/GridItem.js";
import GridContainer from "components/Grid/GridContainer.js";
import Table from "components/Table/Table.js";
import Tasks from "components/Tasks/Tasks.js";
import CustomTabs from "components/CustomTabs/CustomTabs.js";
import Danger from "components/Typography/Danger.js";
import Card from "components/Card/Card.js";
import CardHeader from "components/Card/CardHeader.js";
import CardIcon from "components/Card/CardIcon.js";
import CardBody from "components/Card/CardBody.js";
import CardFooter from "components/Card/CardFooter.js";
import Button from "components/CustomButtons/Button.js";
import ReactDOM from 'react-dom';
import TableSort from "./Extra/Slideer/TableSort.js"

// My Components

import {
  dailySalesChart,
  emailsSubscriptionChart,
  completedTasksChart
} from "variables/charts.js";

import styles from "assets/jss/material-dashboard-react/views/dashboardStyle.js";
import ToogleThings from "views/UserProfile/PageParts/ToogleThings.js";
import EnhancedTable from "./Extra/Slideer/Tables/SortableTableFirstPage.js";
import { Link, Switch } from "@material-ui/core";
import { Add, ShoppingCart } from "@material-ui/icons";
import SimpleSlider from "./Extra/Slideer/SimpleSlider.js";




ReactDOM.render(<TableSort />, document.querySelector('#root'));



const useStyles = makeStyles(styles);

export default function Dashboard() {
  const classes = useStyles();
                                                // Supported Exchanges State
                                                
  const [SupportedComponent,ToggleSupportedComponent] = ToogleThings(
    <GridItem  md={12} sm={12} xs={12}> 
    
      {/* <GridContainer id="orderspositionsbox">
      <GridItem md={3} sm={3} xs={3}>
        <SearchBox></SearchBox> 
      </GridItem>
    
      <GridItem md={3} sm={3} xs={3}>
        <Tooltip placement="top"
        title="Refresh"
        arrow> 
        <Button style={{background:"#12daf2", width:"60px"}}><a style={{color:"white"}} href="#"><Refresh style={{height:"22px",width:"40px"}}/></a></Button>
        </Tooltip>
      </GridItem>
      </GridContainer> */}
    
    
      <GridContainer style={{paddingBottom:"-10px", }}>
    
        <EnhancedTable/>
    
        
        {/* <GridItem >
          <p>Stop Loss Timeout</p>
        </GridItem>
    
        <GridItem style={{marginLeft:"-30px"}}>
          <Tooltip placement="top" 
              title="A double check before triggering the Stop Loss. The system will check conditions when the price reaches them, 
              and additionally after the set amount of seconds passes.
                If Stop Loss condition is not true after the delay, it won’t trigger. 
                A high delay might incur higher losses  " 
                arrow >
            <ContactSupport style={{ width:"20px"}}/>
          </Tooltip>  
        </GridItem>
    
        <GridItem id="tabboxswitch">
          <Switch/>
        </GridItem> */}
    
      </GridContainer>
    
    
    </GridItem>
    
    ,false); 

  return (
    <div>
      
                                         {/* Subscription */}
    

      <GridContainer style={{backgroundColor:"#00acc1",borderRadius:"10px",}}>
          <GridItem xs={6} sm={6} md={6} >
          <p>2 days left in your trial period.</p>
          </GridItem>
          
          <GridItem xs={6} sm={6} md={6} style={{direction:"rtl",}} >
                <Button style={{border:"1px solid white"}} type="button" color="info">Buy Subscription</Button>
          </GridItem>
      </GridContainer>
      
                                {/* Top Tabs  (Dashboard/My Exchanges/Trador's Dirary*/}
      <GridContainer  >

      <GridItem xs={12} sm={12} md={6} style={{marginBottom:"-2.3rem",}}>
          <CustomTabs 
            // title="Tasks:"
            headerColor="primary"
            tabs={[
              
              {
                tabName: "Dashboard",
                tabIcon: Dashboard1,
                tabPath: "/myexchanges",
                component: Typography,
                // tabContent: (
                //   <Tasks
                //     checkedIndexes={[0, 3]}
                //     tasksIndexes={[0, 1, 2, 3]}
                //     tasks={bugs}
                //   />
                // )
              },
              {
                tabName: "My Exchanges",
                tabIcon: LockIcon,
                // tabContent: (
                //   <Tasks
                //     checkedIndexes={[0]}
                //     tasksIndexes={[0, 1]}
                //     tasks={website}
                //   />
                // )
              },
              {
                tabName: "Trador's Diary",
                tabIcon: LibraryBooksIcon,
                // tabContent: (
                //   <Tasks
                //     checkedIndexes={[1]}
                //     tasksIndexes={[0, 1, 2]}
                //     tasks={server}
                //   />
                // )
              }
            ]}
          />
        </GridItem>

        
        {/* <GridItem xs={12} sm={6} md={3}>
          <Card>
            <CardHeader color="warning" stats icon>
              <CardIcon color="warning">
                <Icon>content_copy</Icon>
              </CardIcon>
              <p className={classes.cardCategory}>Used Space</p>
              <h3 className={classes.cardTitle}>
                49/50 <small>GB</small>
              </h3>
            </CardHeader>
            <CardFooter stats>
              <div className={classes.stats}>
                <Danger>
                  <Warning />
                </Danger>
                <a href="#pablo" onClick={e => e.preventDefault()}>
                  Get more space
                </a>
              </div>
            </CardFooter>
          </Card>
        </GridItem>
        <GridItem xs={12} sm={6} md={3}>
          <Card>
            <CardHeader color="success" stats icon>
              <CardIcon color="success">
                <Store />
              </CardIcon>
              <p className={classes.cardCategory}>Revenue</p>
              <h3 className={classes.cardTitle}>$34,245</h3>
            </CardHeader>
            <CardFooter stats>
              <div className={classes.stats}>
                <DateRange />
                Last 24 Hours
              </div>
            </CardFooter>
          </Card>
        </GridItem>
        <GridItem xs={12} sm={6} md={3}>
          <Card>
            <CardHeader color="danger" stats icon>
              <CardIcon color="danger">
                <Icon>info_outline</Icon>
              </CardIcon>
              <p className={classes.cardCategory}>Fixed Issues</p>
              <h3 className={classes.cardTitle}>75</h3>
            </CardHeader>
            <CardFooter stats>
              <div className={classes.stats}>
                <LocalOffer />
                Tracked from Github
              </div>
            </CardFooter>
          </Card>
        </GridItem>
        <GridItem xs={12} sm={6} md={3}>
          <Card>
            <CardHeader color="info" stats icon>
              <CardIcon color="info">
                <Accessibility />
              </CardIcon>
              <p className={classes.cardCategory}>Followers</p>
              <h3 className={classes.cardTitle}>+245</h3>
            </CardHeader>
            <CardFooter stats>
              <div className={classes.stats}>
                <Update />
                Just Updated
              </div>
            </CardFooter>
          </Card>
        </GridItem> */}


      </GridContainer>
      


                                          {/* Dashboard MiddleParts */}
      <GridContainer>
        <GridItem xs={12} sm={12} md={4}>
          <Card chart>
                                            {/* CardHeader are Charts that Commented*/}
            {/* <CardHeader color="success">
              <ChartistGraph
                className="ct-chart"
                data={dailySalesChart.data}
                type="Line"
                options={dailySalesChart.options}
                listener={dailySalesChart.animation}
              />
            </CardHeader> */}
            <CardBody id="topboxes" >
              <h4 style={{borderBottom: "1px solid #eee",  }} className={classes.cardTitle}>My DCA Bots<a href="http://localhost:3000/admin/dcabot"><Button style={{float:"right",width:"25px",height:"25px",marginTop:"-5px",background:"#47d3e4"}}><Add/></Button></a></h4>
              <p className={classes.cardCategory}>
                {/* <span className={classes.successText}>
                  <ArrowUpward className={classes.upArrowCardCategory} /> 55%
                </span>{" "} */}
                A bot hasn't been created yet. Choose a strategy or copy another bot, use signals and get a profit.
              </p>
            </CardBody>
            <CardFooter chart>
              
              <div style={{color:"#579ee0",}} className={classes.stats}>
              <a style={{textDecoration:"none", color:"#579ee0",}} href="#">
                {/* <AccessTime />  */}
                <PhotoSizeSelectSmallIcon/>
                Learn more about Bots
                </a>
              </div>
            </CardFooter>
          </Card>
        </GridItem>


        <GridItem xs={12} sm={12} md={4}>
          <Card chart>
            {/* <CardHeader color="warning">
              <ChartistGraph
                className="ct-chart"
                data={emailsSubscriptionChart.data}
                type="Bar"
                options={emailsSubscriptionChart.options}
                responsiveOptions={emailsSubscriptionChart.responsiveOptions}
                listener={emailsSubscriptionChart.animation}
              />
            </CardHeader> */}
            <CardBody id="topboxes">
              <h4 style={{}} className={classes.cardTitle}>My Smart Trades<a href="http://localhost:3000/admin/smarttrade"><Button style={{float:"right",width:"25px",height:"25px",marginTop:"-5px",background:"#47d3e4"}}><Add/></Button></a></h4>
              {/* <Button style={{backgroundColor:"#00acc1", marginLeft:"180px",}}>+</Button> */}
              
              <p style={{borderTop: "1px solid #eee"}} className={classes.cardCategory}>A Smart Trade hasn't been created yet. Set Take Profit 
              & Stop Loss to start your first trade. Use trailing feature to buy or sell with maximum profit.</p>
            </CardBody>
            <CardFooter chart>
            <div  className={classes.stats}>
                {/* <AccessTime />  */}
                <a style={{textDecoration:"none", color:"#579ee0",}} href="#">
                <PhotoSizeSelectSmallIcon/>
                Learn more about Smart Trades
                </a>
              </div>
            </CardFooter>
          </Card>
        </GridItem>


        <GridItem xs={12} sm={12} md={4}>
          <Card chart>
            {/* <CardHeader color="danger">
              <ChartistGraph
                className="ct-chart"
                data={completedTasksChart.data}
                type="Line"
                options={completedTasksChart.options}
                listener={completedTasksChart.animation}
              />
            </CardHeader> */}
            <CardBody id="topboxes">
              <h4 className={classes.cardTitle}>Marketplace<a href="http://localhost:3000/admin/marketplace"><Button style={{float:"right",width:"25px",height:"25px",marginTop:"-5px",background:"#47d3e4"}}><ShoppingCart/></Button></a></h4>
              <p style={{borderTop: "1px solid #eee"}} className={classes.cardCategory}>Create your own bots based on signals and configurations
               from market professionals.</p>
            </CardBody>
            <CardFooter chart>
             <div style={{color:"#579ee0",}} className={classes.stats}>
             <a style={{textDecoration:"none", color:"#579ee0",}} href="#">
                {/* <AccessTime />  */}
                <PhotoSizeSelectSmallIcon/>
                Learn More About Marketplace
              </a>
              </div>
            </CardFooter>
          </Card>
        </GridItem>

      </GridContainer>

                                      {/* Live Trades*/}
      <GridContainer>

      <GridItem id="ordersandpositions" md={12} sm={12} xs={12}>
                      
        <GridItem  md={12} sm={12} xs={12}> 
              
          <CardHeader style={{marginLeft:"-19px"}} color="primary" stats>
            
            <h4>Live Smartizas trades feed</h4>

            <GridItem md={12} sm={12} xs={12} style={{ marginTop:"-31px", float:"right", marginRight:"-35px"}}>
              {/* <Switch onClick={ToggleSupportedComponent}/> */}
            </GridItem>
          </CardHeader>
          
          <SimpleSlider />  

        </GridItem>
      </GridItem>
        {/* <Card style={{marginBottom:"10px",}}>
          <CardBody style={{fontSize:"20px", borderBottom:"1px solid gray"}}>Live 3Commas trades feed</CardBody>
          <SimpleSlider/>
        </Card> */}


      </GridContainer>
      

                                      {/* DashBoard LastParts */}
      <GridContainer>
      
      <GridItem id="ordersandpositions" md={12} sm={12} xs={12}>
                      
        <GridItem  md={12} sm={12} xs={12}> 
              
          <CardHeader style={{marginLeft:"-19px"}} color="primary" stats>
            
            <h4>Popular DCA Bots</h4>

            <GridItem md={12} sm={12} xs={12} style={{ marginTop:"-31px", float:"right", marginRight:"-35px"}}>
              {/* <Switch onClick={ToggleSupportedComponent}/> */}
            </GridItem>
          </CardHeader>


        </GridItem>
      </GridItem>

        {/* <GridItem xs={12} sm={12} md={6}>
          <CustomTabs
            title="Tasks:"
            headerColor="primary"
            tabs={[
              {
                tabName: "Bugs",
                tabIcon: BugReport,
                tabContent: (
                  <Tasks
                    checkedIndexes={[0, 3]}
                    tasksIndexes={[0, 1, 2, 3]}
                    tasks={bugs}
                  />
                )
              },
              {
                tabName: "Website",
                tabIcon: Code,
                tabContent: (
                  <Tasks
                    checkedIndexes={[0]}
                    tasksIndexes={[0, 1]}
                    tasks={website}
                  />
                )
              },
              {
                tabName: "Server",
                tabIcon: Cloud,
                tabContent: (
                  <Tasks
                    checkedIndexes={[1]}
                    tasksIndexes={[0, 1, 2]}
                    tasks={server}
                  />
                )
              }
            ]}
          />
        </GridItem>
        */}


        <GridItem xs={12} sm={6} md={3}> 
          <Card>
            <CardHeader id="popularheader" color="primary">
              <h4 className={classes.cardTitleWhite}>USDT_OMG</h4>
              {/* <p className={classes.cardCategoryWhite}>
                New employees on 15th September, 2016
              </p> */}
            </CardHeader>
            <CardBody>
              
              <GridContainer style={{backgroundColor:"",borderRadius:"10px", borderBottom:"0.2px solid gray"}}>
                <GridItem xs={6} sm={6} md={6} >
                  <p id="populartext">Profit per day</p>
                  <p id="populartext">Days running</p>
                  <p id="populartext">Deals</p>
                  <p id="populartext">StopLoss</p>
                  <p id="populartext">Last edited</p>
                </GridItem>
            
                <GridItem xs={6} sm={6} md={6} style={{direction:"rtl",}} >
                  <p id="populartext"  className={classes.cardCategory}>
                    <span className={classes.successText}>
                    <ArrowUpward className={classes.upArrowCardCategory} /> 2.98%+
                    </span>{" "}
                  </p>
                  <p id="populartext">17</p>
                  <p id="populartext">6</p>
                  <p style={{color:"red"}} id="populartext">No</p>
                  <p id="populartext">11/16/2020</p>
                </GridItem>
              </GridContainer>

              <Card>
                <Button type="button" color="info">Start Now</Button>
              </Card>
            </CardBody>
          </Card>
        </GridItem>


        <GridItem xs={12} sm={6} md={3}> 
          <Card>
            <CardHeader color="primary">
              <h4 className={classes.cardTitleWhite}>USDT_SXP</h4>
              {/* <p className={classes.cardCategoryWhite}>
                New employees on 15th September, 2016
              </p> */}
            </CardHeader>
            <CardBody>
              
              <GridContainer style={{backgroundColor:"",borderRadius:"10px", borderBottom:"0.2px solid gray"}}>
                <GridItem xs={6} sm={6} md={6} >
                  <p id="populartext">Profit per day</p>
                  <p id="populartext">Days running</p>
                  <p id="populartext">Deals</p>
                  <p id="populartext">StopLoss</p>
                  <p id="populartext">Last edited</p>
                </GridItem>
            
                <GridItem xs={6} sm={6} md={6} style={{direction:"rtl",}} >
                <p id="populartext"  className={classes.cardCategory}>
                    <span className={classes.successText}>
                    <ArrowUpward className={classes.upArrowCardCategory} /> 2.98%+
                    </span>{" "}
                  </p>
                  <p id="populartext">17</p>
                  <p id="populartext">6</p>
                  <p style={{color:"red"}} id="populartext">No</p>
                  <p id="populartext">11/16/2020</p>
                </GridItem>
              </GridContainer>

              <Card>
                <Button type="button" color="info">Start Now</Button>
              </Card>
            </CardBody>
          </Card>
        </GridItem>


        <GridItem xs={12} sm={6} md={3}> 
          <Card>
            <CardHeader color="primary">
              <h4 className={classes.cardTitleWhite}>USDT_ALGO</h4>
              {/* <p className={classes.cardCategoryWhite}>
                New employees on 15th September, 2016
              </p> */}
            </CardHeader>
            <CardBody>
            
              <GridContainer style={{backgroundColor:"",borderRadius:"10px", borderBottom:"0.2px solid gray"}}>
                <GridItem xs={6} sm={6} md={6} >
                  <p id="populartext">Profit per day</p>
                  <p id="populartext">Days running</p>
                  <p id="populartext">Deals</p>
                  <p id="populartext">StopLoss</p>
                  <p id="populartext">Last edited</p>
                </GridItem>
            
                <GridItem xs={6} sm={6} md={6} style={{direction:"rtl",}} >
                <p id="populartext"  className={classes.cardCategory}>
                    <span className={classes.successText}>
                    <ArrowUpward className={classes.upArrowCardCategory} /> 2.98%+
                    </span>{" "}
                  </p>
                  <p id="populartext">17</p>
                  <p id="populartext">6</p>
                  <p style={{color:"red"}} id="populartext">No</p>
                  <p id="populartext">11/16/2020</p>
                </GridItem>
              </GridContainer>

              <Card>
                <Button type="button" color="info">Start Now</Button>
              </Card>
            </CardBody>
          </Card>
        </GridItem>

        
        <GridItem xs={12} sm={6} md={3}> 
          <Card>
            <CardHeader color="primary">
              <h4 className={classes.cardTitleWhite}>USDT_DASH</h4>
              {/* <p className={classes.cardCategoryWhite}>
                New employees on 15th September, 2016
              </p> */}
            </CardHeader>
            <CardBody>
            
              <GridContainer style={{backgroundColor:"",borderRadius:"10px", borderBottom:"0.2px solid gray"}}>
                <GridItem xs={6} sm={6} md={6} >
                  <p id="populartext">Profit per day</p>
                  <p id="populartext">Days running</p>
                  <p id="populartext">Deals</p>
                  <p id="populartext">StopLoss</p>
                  <p id="populartext">Last edited</p>
                </GridItem>
            
                <GridItem xs={6} sm={6} md={6} style={{direction:"rtl",}} >
                <p id="populartext"  className={classes.cardCategory}>
                    <span className={classes.successText}>
                    <ArrowUpward className={classes.upArrowCardCategory} /> 2.98%+
                    </span>{" "}
                  </p>
                  <p id="populartext">17</p>
                  <p id="populartext">6</p>
                  <p style={{color:"red"}} id="populartext">No</p>
                  <p id="populartext">11/16/2020</p>
                </GridItem>
              </GridContainer>

              <Card>
                <Button type="button" color="info">Start Now</Button>
              </Card>
            </CardBody>
          </Card>
        </GridItem>


        {/* <GridItem xs={12} sm={6} md={4}> 
          <Card>
            <CardHeader color="warning">
              <h4 className={classes.cardTitleWhite}>Employees Stats</h4>
              <p className={classes.cardCategoryWhite}>
                New employees on 15th September, 2016
              </p>
            </CardHeader> 
            <CardBody>
              <Table
                tableHeaderColor="warning"
                tableHead={["ID", "Name", "Salary", "Country"]}
                tableData={[
                  ["1", "Dakota Rice", "$36,738", "Niger"],
                  ["2", "Minerva Hooper", "$23,789", "Curaçao"],
                  ["3", "Sage Rodriguez", "$56,142", "Netherlands"],
                  ["4", "Philip Chaney", "$38,735", "Korea, South"]
                ]}
              />
              <CardBody>
                <Button type="button" color="info">Start Now</Button>
              </CardBody>
            </CardBody>
          </Card>
        </GridItem> */}

                                      {/* Supported Exchanges Part */}

        
        
      {/* <GridContainer md={12} sm={12} xs={12} style={{backgroundColor:"white",borderRadius:"10px",}}> */}
        
      <GridItem id="ordersandpositions" md={12} sm={12} xs={12}>
                      
                      <GridItem  md={12} sm={12} xs={12}> 
                            
                            <CardHeader style={{marginLeft:"-19px"}} color="primary" stats>
                              
                              <h4>Supported exchanges</h4>
              
                              <GridItem md={12} sm={12} xs={12} style={{ marginTop:"-31px", float:"right", marginRight:"-35px"}}>
                                <Switch onClick={ToggleSupportedComponent}/>
                              </GridItem>
                            </CardHeader>
              
                            {SupportedComponent}
                        
              
                      </GridItem>
      </GridItem>
                
          
        
      {/* </GridContainer> */}
          <div id="root"></div>
    </GridContainer>
    </div>
  );
}
